<template>
  <div id="contenedor-main-listado-auditorias-informes-observaciones">
    <template v-if="!$vuetify.breakpoint.xs">
      <desktop
        :items="listadoObservaciones"
        :informe="informe"
        >
      </desktop>
    </template>
    <template v-else>
      <desktop
        :items="listadoObservaciones"
        :informe="informe"
        >
      </desktop>
      <!-- <mobile :listadoObservaciones="listadoObservaciones"></mobile> -->
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoAuditoriasInformesObservaciones',
  props: {
    listadoObservaciones: {
      type: Array,
      required: true,
    },
    informe: {
      type: Object,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
